import { render, staticRenderFns } from "./MouMoaList.vue?vue&type=template&id=c2c55a00&scoped=true"
import script from "./MouMoaList.vue?vue&type=script&lang=js"
export * from "./MouMoaList.vue?vue&type=script&lang=js"
import style0 from "./MouMoaList.vue?vue&type=style&index=0&id=c2c55a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c55a00",
  null
  
)

export default component.exports